import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LinkModule } from '../../atoms/link/link.module';
import { ButtonModule } from '../../forms/button/button.module';
import { ErrorMessageComponent } from './error-message.component';

@NgModule({
  declarations: [ErrorMessageComponent],
  imports: [CommonModule, LinkModule, ButtonModule],
  exports: [ErrorMessageComponent]
})
export class ErrorMessageModule {}
